export class ListAzureSubnets200ResponseSubnetsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "addressPrefix",
            "baseName": "addressPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "delegations",
            "baseName": "delegations",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSubnets200ResponseSubnetsInner.attributeTypeMap;
    }
    constructor() {
    }
}
